import { render, staticRenderFns } from "./ReSet.vue?vue&type=template&id=b29d9d80&scoped=true&"
import script from "./ReSet.vue?vue&type=script&lang=js&"
export * from "./ReSet.vue?vue&type=script&lang=js&"
import style0 from "./ReSet.vue?vue&type=style&index=0&id=b29d9d80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29d9d80",
  null
  
)

export default component.exports